module.exports = __webpack_public_path__ + "static/media/view4.0bd7f8b4.jpg";